import React from 'react';
import { Mail, Globe, Send, MessageSquare } from 'lucide-react';
import Layout from '../components/Layout';
import { Btn, PageHeader, Section } from '../components/UI';

export default function ContactPage() {
  const email = 'contact@cytometrix.ca';
  const website = 'https://cytometrix.ca';

  return (
    <Layout>
      <PageHeader title="Contact Us" subtitle="We're here to help with any questions or support needs." />

      <div style={{ maxWidth: 640, margin: '0 auto' }}>
        {/* Contact cards — stack on mobile */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 14, marginBottom: 20 }}>
          <a href={`mailto:${email}`} style={{ textDecoration: 'none' }}>
            <div style={{ background: '#fff', borderRadius: 16, padding: '20px 18px', border: '1px solid var(--gray-200)', boxShadow: 'var(--shadow-sm)', cursor: 'pointer', transition: 'all 0.2s' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--blue)'; e.currentTarget.style.boxShadow = '0 4px 20px rgba(30,111,255,0.12)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--gray-200)'; e.currentTarget.style.boxShadow = 'var(--shadow-sm)'; }}>
              <div style={{ width: 42, height: 42, borderRadius: 11, background: 'var(--blue-pale)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
                <Mail size={20} color="var(--blue)" />
              </div>
              <p style={{ fontSize: 12, fontWeight: 700, color: 'var(--gray-500)', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 5 }}>Email</p>
              <p style={{ fontSize: 14, fontWeight: 600, color: 'var(--blue)' }}>{email}</p>
            </div>
          </a>

          <a href={website} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
            <div style={{ background: '#fff', borderRadius: 16, padding: '20px 18px', border: '1px solid var(--gray-200)', boxShadow: 'var(--shadow-sm)', cursor: 'pointer', transition: 'all 0.2s' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--teal)'; e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,194,168,0.12)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--gray-200)'; e.currentTarget.style.boxShadow = 'var(--shadow-sm)'; }}>
              <div style={{ width: 42, height: 42, borderRadius: 11, background: 'var(--teal-soft)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
                <Globe size={20} color="var(--teal)" />
              </div>
              <p style={{ fontSize: 12, fontWeight: 700, color: 'var(--gray-500)', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 5 }}>Website</p>
              <p style={{ fontSize: 14, fontWeight: 600, color: 'var(--teal)' }}>www.cytometrix.ca</p>
            </div>
          </a>
        </div>

        <Section>
          <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
            <div style={{ width: 42, height: 42, borderRadius: 11, background: 'var(--blue-pale)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <MessageSquare size={20} color="var(--blue)" />
            </div>
            <div style={{ flex: 1 }}>
              <h3 style={{ fontSize: 15, fontWeight: 700, color: 'var(--navy)', marginBottom: 6 }}>Get in Touch</h3>
              <p style={{ fontSize: 13, color: 'var(--gray-500)', lineHeight: 1.7, marginBottom: 18 }}>
                Whether you have technical questions, need support with the platform, or want to learn more about our diagnostic capabilities — our team is ready to assist you.
              </p>
              <Btn icon={Send} onClick={() => window.location.href = `mailto:${email}`}>Send Email</Btn>
            </div>
          </div>
        </Section>

        <div style={{ background: 'var(--navy)', borderRadius: 16, padding: '20px 22px', color: '#fff' }}>
          <p style={{ fontSize: 14, fontWeight: 700, marginBottom: 5 }}>Support Hours</p>
          <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.55)', lineHeight: 1.7 }}>
            Monday – Friday: 9:00 AM – 5:00 PM (PT)<br />
            We aim to respond to all inquiries within 1 business day.
          </p>
        </div>
      </div>
    </Layout>
  );
}

